function getType(context) {
  return context.$route.path.includes('routecontrols') ? 'tc' : 'site';
}

const privs = {
  site: 'pr_site',
  tc: 'pr_tc'
};

const urls = {
  site: '/sites/exportlayouts',
  tc: '/routecontrols/exportlayouts'
};

const filterNames = {
  site: 'siteexportlayouts',
  tc: 'tcexportlayouts'
};

const newRecords = {
  site: {
    report_layout_type: 1,
    devicegroup_id: 3
  },
  tc: {
    report_layout_type: 1,
    devicegroup_id: 6
  }
};

export default {
  priv(context) {
    return privs[getType(context)];
  },
  overviewTitle: 'Layout Export',
  detailTitle: 'Layout Export',
  deleteTitle: 'dit bestand',
  url(context) {
    return urls[getType(context)];
  },
  apiUrl: '/sitereportlayouts/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName(context) {
    return filterNames[getType(context)];
  },
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'str'
  },
  newRecord(context) {
    return newRecords[getType(context)];
  },
  tableFields(context) {
    return [
      {
        text: 'Naam',
        value: 'name',
        link: urls[getType(context)] + '/{id}',
        width: '30%'
      },
      {
        text: 'Bestandsnaam',
        value: 'file.name',
        width: '30%'
      },
      {
        text: 'Grootte',
        value: 'file.size',
        width: '20%',
        filter: 'prettyBytes'
      }
    ];
  }
};
